<template>
    <div class="footer">
        <div class="box tag">
            <FooterTag/>
        </div>
        <div class="box browse">
            <div class="foot-heading">
                Browse
            </div>
            <div class="tiny-links">
                <router-link to="/" class="tiny-link">Home</router-link>
                <router-link to="/about" class="tiny-link">About</router-link>
                <router-link to="/work-education" class="tiny-link">Work & Education</router-link>
                <router-link to="/sample-projects" class="tiny-link">Sample Projects</router-link>
                <router-link to="/contacts" class="tiny-link">Contacts</router-link>
            </div>
        </div>
        <div class="box contacts">
            <div class="foot-heading">
                Contacts
            </div>
            <FooterContactsPage/>
        </div>
        <div class="copyright">
            Copyright &copy; {{ year }}. &nbsp; All Rights Reserved
        </div>
    </div>
</template>
<script>
import FooterContactsPage from './FooterContactsPage.vue';
import FooterTag from './FooterTag.vue';

export default{
    data(){
        return{
            year: ""
        }
    },
    created(){
        let _date = new Date();
        this.year = _date.getFullYear();
    },
    components:{
        FooterContactsPage, FooterTag
    }

}
</script>
<style scoped>

.tiny-link.router-link-exact-active{
        color:var(--gold);
    }

    .footer{
        background-color: var(--blue);
        color:white;
        display:grid;
        grid-template-columns: repeat(3,1fr);
        grid-template-rows:auto, auto;
    }

    .box{
        min-height: 13rem;
        padding:1rem;
    }



    .copyright{
        padding:0.4rem;
        font-size:0.8rem;
        grid-column:1/4;
        background-color: var(--blue4);
    }

   

    .tiny-links{
        display: flex;
        flex-direction: column;
    }

    .tiny-link{
        color:white;
        text-decoration:none;
        font-size:0.9rem;
        margin-bottom:0.4rem;
    }

    @media(max-width: 768px){
        .footer{
        grid-template-columns: repeat(4,1fr);
        grid-template-rows:auto auto auto;
        }

        .copyright{
            grid-row:3/4;
            grid-column:1/5;
        }

        .tag{
            grid-column:1/3;
        }

        .browse{
            grid-column:3/5;
        }

        .contacts{
            grid-row:2/3;
            grid-column:1/5;
        }

        .box{
        min-height: 8rem;
        
    }
    }
</style>